import { render, staticRenderFns } from "./SkeletonLoading.vue?vue&type=template&id=e5a90be6&scoped=true&"
import script from "./SkeletonLoading.vue?vue&type=script&lang=js&"
export * from "./SkeletonLoading.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonLoading.vue?vue&type=style&index=0&id=e5a90be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a90be6",
  null
  
)

export default component.exports